module.exports = __webpack_public_path__ + "static/media/work_better.2e41b251.jpg";